import React from "react";

import {
  FaEdit,
  FaEye,
  FaSpinner,
  FaUserCircle,
} from "react-icons/fa";

import {
  FiShield,
} from "react-icons/fi";

import EmployeePagination
  from "../common/EmployeePagination";

import EmployeeStatusBadge
  from "../common/EmployeeStatusBadge";

import {
  formatEmployeeCurrency,
  formatEmployeeDate,
  formatEmployeeLabel,
} from "../utils/employee.utils";

import "./EmployeeManagement.css";


const EmployeeTable = ({
  employees = [],

  loading = false,

  page = 1,

  limit = 10,

  totalRecords = 0,

  totalPages = 1,

  onPageChange,

  onLimitChange,

  onView,

  onEdit,

  onChangeStatus,
}) => {

  if (
    loading
  ) {

    return (

      <div className="employee-table-loading">

        <FaSpinner className="employee-table-spinner" />

        <span>
          Loading employees...
        </span>

      </div>

    );

  }


  return (

    <section className="employee-table-card">

      <div className="employee-table-card-header">

        <div>

          <span>
            EMPLOYEE LIST
          </span>

          <h2>
            Employee Records
          </h2>

          <p>
            View employee details, salary configuration and account access.
          </p>

        </div>

      </div>


      <div className="employee-table-scroll">

        <table className="employee-table">

          <thead>

            <tr>

              <th>#</th>

              <th>
                Employee
              </th>

              <th>
                Department
              </th>

              <th>
                Employment
              </th>

              <th>
                Joining Date
              </th>

              <th>
                Net Salary
              </th>

              <th>
                Login
              </th>

              <th>
                Status
              </th>

              <th>
                Actions
              </th>

            </tr>

          </thead>


          <tbody>

            {
              employees.length ===
              0
                ?
                (
                  <tr>

                    <td
                      colSpan="9"
                      className="employee-table-empty"
                    >

                      <FaUserCircle />

                      <strong>
                        No employees found
                      </strong>

                      <span>
                        Try changing your filters or add a new employee.
                      </span>

                    </td>

                  </tr>
                )
                :
                employees.map(
                  (
                    employee,
                    index
                  ) => {

                    const adminUser =
                      employee?.userId &&
                      typeof employee.userId ===
                        "object"
                        ?
                        employee.userId
                        :
                        null;


                    const role =
                      adminUser?.roleId &&
                      typeof adminUser.roleId ===
                        "object"
                        ?
                        adminUser.roleId
                        :
                        null;


                    const loginActive =
                      Boolean(
                        adminUser
                      ) &&
                      String(
                        adminUser?.status ||
                        ""
                      )
                        .toUpperCase() ===
                      "ACTIVE";


                    return (

                      <tr
                        key={
                          employee._id
                        }
                      >

                        <td>
                          {
                            (
                              Number(
                                page
                              ) -
                              1
                            ) *
                            Number(
                              limit
                            ) +
                            index +
                            1
                          }
                        </td>


                        <td>

                          <div className="employee-table-person">

                            <div className="employee-table-avatar">

                              {
                                employee?.profileImage
                                  ?
                                  (
                                    <img
                                      src={
                                        employee.profileImage
                                      }
                                      alt={
                                        employee.name
                                      }
                                    />
                                  )
                                  :
                                  (
                                    <FaUserCircle />
                                  )
                              }

                            </div>


                            <div>

                              <strong>
                                {
                                  employee?.name ||
                                  "-"
                                }
                              </strong>

                              <span>
                                {
                                  employee?.employeeCode ||
                                  "-"
                                }
                              </span>

                              <small>
                                {
                                  employee?.mobile ||
                                  "-"
                                }
                              </small>

                            </div>

                          </div>

                        </td>


                        <td>

                          <strong className="employee-table-primary-text">
                            {
                              employee?.department ||
                              "-"
                            }
                          </strong>

                          <span className="employee-table-secondary-text">
                            {
                              employee?.designation ||
                              "-"
                            }
                          </span>

                        </td>


                        <td>

                          <span className="employee-table-secondary-text">

                            {
                              formatEmployeeLabel(
                                employee?.employmentType
                              )
                            }

                          </span>

                        </td>


                        <td>

                          {
                            formatEmployeeDate(
                              employee?.joiningDate
                            )
                          }

                        </td>


                        <td>

                          <strong className="employee-table-salary">

                            {
                              formatEmployeeCurrency(
                                employee
                                  ?.salary
                                  ?.netSalary
                              )
                            }

                          </strong>

                        </td>


                        <td>

                          {
                            adminUser
                              ?
                              (
                                <div className="employee-table-login">

                                  <span
                                    className={
                                      loginActive
                                        ?
                                        "active"
                                        :
                                        "inactive"
                                    }
                                  />

                                  <div>

                                    <strong>
                                      {
                                        loginActive
                                          ?
                                          "Enabled"
                                          :
                                          "Disabled"
                                      }
                                    </strong>

                                    <small>
                                      {
                                        role?.name ||
                                        "No role"
                                      }
                                    </small>

                                  </div>

                                </div>
                              )
                              :
                              (
                                <span className="employee-table-no-login">
                                  No Login
                                </span>
                              )
                          }

                        </td>


                        <td>

                          <EmployeeStatusBadge
                            status={
                              employee?.status
                            }
                          />

                        </td>


                        <td>

                          <div className="employee-table-actions">

                            <button
                              type="button"
                              className="employee-action-view"
                              onClick={
                                () =>
                                  onView?.(
                                    employee
                                  )
                              }
                              title="View"
                            >

                              <FaEye />

                            </button>


                            <button
                              type="button"
                              className="employee-action-edit"
                              onClick={
                                () =>
                                  onEdit?.(
                                    employee
                                  )
                              }
                              title="Edit"
                            >

                              <FaEdit />

                            </button>


                            <button
                              type="button"
                              className="employee-action-status"
                              onClick={
                                () =>
                                  onChangeStatus?.(
                                    employee
                                  )
                              }
                              title="Change Status"
                            >

                              <FiShield />

                            </button>

                          </div>

                        </td>

                      </tr>

                    );

                  }
                )
            }

          </tbody>

        </table>

      </div>


      {
        totalRecords >
        0
          ?
          (
            <EmployeePagination
              page={page}
              limit={limit}
              totalRecords={
                totalRecords
              }
              totalPages={
                totalPages
              }
              onPageChange={
                onPageChange
              }
              onLimitChange={
                onLimitChange
              }
            />
          )
          :
          null
      }

    </section>

  );

};


export default EmployeeTable;